<ds-loading *ngIf="loader === true"></ds-loading>
<div class="flex flex-col max-w-240 md:min-w-160 -m-6">

    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{hdng_nm}} Address</div>
        <button mat-icon-button (click)="Close()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="close"></mat-icon>
        </button>
    </div>
    <form [formGroup]="addressForm" class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
       

        
        <div class="flex flex-row">
            <mat-form-field class="frmfld m-2">
                <mat-label>Select Location Type</mat-label>
                <mat-select formControlName="lctn_type_id" placeholder="Select Location Type" (selectionChange)="onLctnTypChnge($event.value)">
                    <mat-option *ngFor="let l of lctnTypsLst" [value]="l">{{l.lctn_type_nm}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="flex flex-row">
            <mat-form-field class="frmfld m-2">
                <mat-label>Address Name</mat-label>
                <input matInput  formControlName="adrs_nm">
            </mat-form-field>
        </div>
        <div *ngIf="shwAddrsFrm">
        <div class="flex flex-row">

            <mat-form-field class="frmfld m-2">
                <mat-label>Select State</mat-label>
                <mat-select formControlName="ste_id" placeholder="Select State" (selectionChange)="onSteChnge($event)">
                    <mat-option *ngFor="let s of stetsLst" [value]="s.ste_id">{{s.ste_nm}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="frmfld m-2">
                <mat-label>Select District</mat-label>
                <mat-select formControlName="dstrt_id" placeholder="Select District">
                    <mat-option *ngFor="let d of dstrctsLst" [value]="d.dstrt_id">{{d.dstrt_nm}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="flex flex-row">
            <mat-form-field class="frmfld m-2">
                <mat-label>Door No.</mat-label>
                <input matInput [placeholder]="'Door No'" formControlName="dr_nu">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:office-building'"></mat-icon>
            </mat-form-field>
            <mat-form-field class="frmfld m-2">
                <mat-label>City</mat-label>
                <input matInput [placeholder]="'City'" formControlName="ctry_nm">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:office-building'"></mat-icon>
            </mat-form-field>
        </div>
        <div class="flex flex-row">
            <mat-form-field class="m-2" appearance="fill">
                <mat-label>Address-1</mat-label>
                <input matInput [placeholder]="'Door No/apartment name/street name'"  formControlName="adrs1_tx">
            </mat-form-field>
            <mat-form-field class="m-2" appearance="fill">
                <mat-label>Address-2</mat-label>
                <input matInput [placeholder]="'Land marks'"  formControlName="adrs2_tx">
            </mat-form-field>
           
        </div>
    </div>
            <div class="flex flex-row" *ngIf="shwGeoLctns">
                <mat-form-field class="frmfld m-2">
                    <mat-label>Lattitude</mat-label>
                    <input matInput [placeholder]="'City'" formControlName="lat">
                    <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:location-marker'"></mat-icon>
                </mat-form-field>
                <mat-form-field class="frmfld m-2">
                    <mat-label>Longitude</mat-label>
                    <input matInput [placeholder]="'City'" formControlName="lng">
                    <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:location-marker'"></mat-icon>
                </mat-form-field>
                <div class="mt-4">
                    <button class="order-first sm:order-last mt-4 " mat-flat-button [color]="'primary'" (click)="getLocation()">
                        Get Location
                    </button>
                </div>
            </div>
        
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">
            </div>
            <div class="flex items-center mt-4 sm:mt-0">
                <button class="ml-auto sm:ml-0 m-2" mat-button (click)="Close()">
                    Cancel
                </button>
                <button mat-button [color]="'warn'" [matTooltip]="'Delete'" *ngIf="dialogData.edit_in ==1" (click)="delete()">
                    Delete
                </button>
                <button class="order-first sm:order-last m-2" mat-flat-button [color]="'primary'" (click)="send()">
                    {{sve_btn}}
                </button>
            </div>
        </div>

    </form>

    <ng-template #deleteAdrsCnfrmDialog>
        <h2 matDialogTitle>Are You Sure Want To Delete This Address?</h2>
        <mat-dialog-actions align="end">
            <button mat-button (click)="closeDialog()">No</button>
            <button mat-button (click)="deleteAdrs()">Yes</button>
        </mat-dialog-actions>
    </ng-template>
</div>